import { BatchItem, FILE_STATES } from "@rpldy/uploady";
import React, { useCallback } from "react";
import { FileList } from "shared/components/file/FileList";
import { FileListItem } from "shared/components/file/FileListItem";
import { FileState } from "shared/components/file/FileState";
import { useFileUploadController } from "shared/components/upload/FileUploadController";

export const FileUploadList: React.FC<{
  itemFilter?: (item: BatchItem) => boolean;
}> = ({ itemFilter = () => true }) => {
  const { items, retryItem, abortItem } = useFileUploadController();
  if (!items.length) {
    return null;
  }
  return (
    <FileList>
      {items.filter(itemFilter).map((item) => (
        <FileUploadListItem
          key={item.id}
          item={item}
          onRetry={retryItem}
          onRemove={abortItem}
        />
      ))}
    </FileList>
  );
};

const FileUploadListItem: React.FC<{
  item: BatchItem;
  onRetry: (item: BatchItem) => void;
  onRemove: (item: BatchItem) => void;
}> = ({ item, onRetry, onRemove }) => {
  const onClickRetry = useCallback(() => {
    onRetry(item);
  }, [item, onRetry]);
  const onClickRemove = useCallback(() => {
    onRemove(item);
  }, [item, onRemove]);
  return (
    <FileListItem
      fileName={item.file.name}
      fileSize={item.file.size}
      state={batchStateToItemState[item.state]}
      progress={item.completed}
      onClickRetry={onClickRetry}
      onClickRemove={onClickRemove}
    />
  );
};

const batchStateToItemState: Record<FILE_STATES, FileState> = {
  [FILE_STATES.PENDING]: "queued",
  [FILE_STATES.FINISHED]: "uploading_complete",
  [FILE_STATES.UPLOADING]: "uploading",
  [FILE_STATES.ERROR]: "uploading_failed",
  [FILE_STATES.ABORTED]: "uploading_cancelled",
  [FILE_STATES.CANCELLED]: "uploading_cancelled",
  [FILE_STATES.ADDED]: "idle",
};
